import React, { useEffect }  from 'react'
import { useDispatch } from 'react-redux';
// import { initializeDropDownValues } from '@commonActions/DropDownActions';
import { HttpClient } from '../../commonApis/httpClient';
import { initializeDropDownValues } from '../AES_App/reducer/dropDownSlice';
// const data={
 
//         "destinationProvince": [
//             {
//                 "additionalInfo": "",
//                 "value": "51",
//                 "text": "CEUTA",
//                 "text_es": "CEUTA",
//                 "id": 204547
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "52",
//                 "text": "MELILLA",
//                 "text_es": "MELILLA",
//                 "id": 204548
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "51",
//                 "text": "CEUTA",
//                 "text_es": "CEUTA",
//                 "id": 209259
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "52",
//                 "text": "MELILLA",
//                 "text_es": "MELILLA",
//                 "id": 209260
//             }
//         ],
//         "declarationType": [
//             {
//                 "additionalInfo": "",
//                 "value": "A",
//                 "text": "for a standard customs declaration (under Article 162 of the Code)",
//                 "text_es": "Para una declaración en aduana normal ( según el artículo 162 del CAU).",
//                 "id": 208881
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "B",
//                 "text": "for a simplified declaration on occasional basis (under Article 166(1) of the Code)",
//                 "text_es": "Para una declaración en aduana simplificada de carácter ocasional ( según el artículo 166.1. del CAU).",
//                 "id": 208882
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "C",
//                 "text": "for a simplified customs declaration with regular use (under Article 166(2) of the Code)",
//                 "text_es": "Para una declaración en aduana simplificada de carácter habitual ( según el artículo 166.2. del CAU).",
//                 "id": 208883
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "D",
//                 "text": "For lodging a standard customs declaration (such as referred to under code A) in accordance with Article 171 of the Code.",
//                 "text_es": "Para la presentación de una declaración normal en aduana (tal como se contempla en el código A) de conformidad con el artículo 171 del Código.",
//                 "id": 208884
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E",
//                 "text": "For lodging a simplified declaration (such as referred to under code B) in accordance with Article 171 of the Code.",
//                 "text_es": "Para la presentación de una declaración en aduana simplificada (tal como se contempla en el código B) de conformidad con el artículo 171 del Código.",
//                 "id": 208885
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "F",
//                 "text": "For lodging a simplified declaration (such as referred to under code C) in accordance with Article 171 of the Code.",
//                 "text_es": "Para la presentación de una declaración en aduana simplificada (tal como se contempla en el código C) de conformidad con el artículo 171 del Código.",
//                 "id": 208886
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X",
//                 "text": "for a supplementary declaration of simplified declarations covered by B and E",
//                 "text_es": "Para una declaración complementaria de declaraciones simplificadas tipo B y E.",
//                 "id": 208887
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y",
//                 "text": "for a supplementary declaration of simplified declarations covered by C and F",
//                 "text_es": "Para una declaración complementaria de declaraciones simplificadas tipo C y F.",
//                 "id": 208888
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Z",
//                 "text": "for a supplementary declaration under the procedure covered under Article 182 of the Code",
//                 "text_es": "Para una declaración complementaria que corresponda al procedimiento contmplado en el artículo 182 del CAU.",
//                 "id": 208889
//             }
//         ],
//         "specialCountryKeys": [
//             {
//                 "additionalInfo": "",
//                 "value": "QX",
//                 "text": "Countries not spec com/mil reasons",
//                 "text_es": "Países no especificados com/mil razones",
//                 "id": 208847
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "QY",
//                 "text": "Countries n/s com/mil intra-Comm",
//                 "text_es": "Países n/s com/mil intra-comm",
//                 "id": 208848
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "QZ",
//                 "text": "Countries n/s com/mil 3rd countries",
//                 "text_es": "Países n/s com/mil 3rd países",
//                 "id": 208849
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "RS",
//                 "text": "Serbia",
//                 "text_es": "Serbia",
//                 "id": 208850
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "XI",
//                 "text": "United Kingdom (Northern Ireland)",
//                 "text_es": "Reino Unido (Irlanda del Norte)",
//                 "id": 208851
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AX",
//                 "text": "LAND ISLANDS",
//                 "text_es": "Islas terrestres",
//                 "id": 209163
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GF",
//                 "text": "French Guyana",
//                 "text_es": "Guyana francesa",
//                 "id": 209164
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GG",
//                 "text": "Guernsey",
//                 "text_es": "Guía",
//                 "id": 209165
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GP",
//                 "text": "Guadeloupe",
//                 "text_es": "Guadeloupo",
//                 "id": 209166
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "IM",
//                 "text": "Isle of Man",
//                 "text_es": "Isla del hombre",
//                 "id": 209167
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "JE",
//                 "text": "Jersey",
//                 "text_es": "Jersey",
//                 "id": 209168
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MC",
//                 "text": "Monaco",
//                 "text_es": "Mónaco",
//                 "id": 209169
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MF",
//                 "text": "Saint Martin (French part)",
//                 "text_es": "San Martín (parte francesa)",
//                 "id": 209170
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MQ",
//                 "text": "Martinique",
//                 "text_es": "Martinica",
//                 "id": 209171
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "RE",
//                 "text": "Réunion",
//                 "text_es": "Reunión",
//                 "id": 209172
//             }
//         ],
//         "postalCodeList": [
//             {
//                 "additionalInfo": "",
//                 "value": "AE",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209055
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209056
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209057
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209058
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209059
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BF",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209060
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209061
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BJ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209062
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209063
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209064
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BQ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209065
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BS",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209066
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209067
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BZ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209068
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CD",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209069
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CF",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209070
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209071
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209072
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CK",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209073
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209074
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209075
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209076
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "DJ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209077
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "DM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209078
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ER",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209079
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "FJ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209080
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GD",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209081
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GH",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209082
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209083
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GN",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209084
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GQ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209085
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GY",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209086
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "HK",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209087
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "IE",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209088
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "JM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209089
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209090
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209091
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KN",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209092
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KP",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209093
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "LC",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209094
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "LY",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209095
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ML",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209096
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209097
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MR",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209098
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209099
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NR",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209100
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NU",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209101
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "PA",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209102
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "QA",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209103
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SB",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209104
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SC",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209105
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SL",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209106
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SR",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209107
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SS",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209108
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ST",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209109
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SX",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209110
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SY",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209111
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TD",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209112
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TF",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209113
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209114
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TK",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209115
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TL",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209116
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209117
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TV",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209118
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TZ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209119
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "UG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209120
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "VU",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209121
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "YE",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209122
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ZW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209123
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AE",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209261
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209262
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209263
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209264
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "AW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209265
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BF",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209266
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209267
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BJ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209268
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209269
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209270
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BQ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209271
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BS",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209272
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209273
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "BZ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209274
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CD",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209275
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CF",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209276
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209277
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209278
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CK",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209279
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209280
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209281
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "CW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209282
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "DJ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209283
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "DM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209284
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ER",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209285
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "FJ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209286
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GD",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209287
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GH",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209288
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209289
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GN",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209290
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GQ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209291
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "GY",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209292
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "HK",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209293
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "IE",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209294
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "JM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209295
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KI",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209296
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KM",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209297
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KN",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209298
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "KP",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209299
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "LC",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209300
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "LY",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209301
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ML",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209302
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209303
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MR",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209304
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209305
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NR",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209306
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NU",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209307
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "PA",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209308
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "QA",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209309
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SB",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209310
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SC",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209311
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SL",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209312
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SR",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209313
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SS",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209314
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ST",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209315
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SX",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209316
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "SY",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209317
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TD",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209318
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TF",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209319
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209320
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TK",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209321
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TL",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209322
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TO",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209323
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TV",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209324
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "TZ",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209325
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "UG",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209326
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "VU",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209327
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "YE",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209328
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ZW",
//                 "text": "Without description",
//                 "text_es": "Sin Descripción",
//                 "id": 209329
//             }
//         ],
//         "additionalInfoCodes": [
//             {
//                 "additionalInfo": "",
//                 "value": "A004",
//                 "text": "Certificate of authenticity Tobacco",
//                 "text_es": "Certificado de autenticidad Tabaco",
//                 "id": 208904
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X803",
//                 "text": "Export authorization under articles 1e.4 and 1FA.1 of Regulation (CE) No. 765/2006",
//                 "text_es": "Autorización de exportación en virtud de los artículos 1e.4 y 1fa.1 del Reglamento (CE) n.º 765/2006",
//                 "id": 208905
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X804",
//                 "text": "The prohibitions defined in articles 1e.1 and 1f.1 of Regulation (CE) No. 765/2006 of the Council are not applied (see the contractual exemptions in the A",
//                 "text_es": "No se aplican las prohibiciones definidas en los artículos 1e.1 y 1f.1 del Reglamento (CE) n.º 765/2006 del Consejo (véanse las exenciones contractuales en el a",
//                 "id": 208906
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X817",
//                 "text": "Export authorization under article 3 Septies (4) of Regulation (EU) 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3 septies (4) del Reglamento (UE) 833/2014 del Consejo",
//                 "id": 208907
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X819",
//                 "text": "Export authorization under article 3c.6 of Regulation (EU) 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3c.6 del Reglamento (UE) 833/2014 del Consejo",
//                 "id": 208908
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X823",
//                 "text": "Export authorization under article 3 nonies, section 4, of Regulation (EU) No. 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3 nonies, apartado 4, del Reglamento (UE) n.º 833/2014 del Consejo",
//                 "id": 208909
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X830",
//                 "text": "Export authorization under article 3 quater, section 6, of Regulation (EU) No. 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3 quater, apartado 6, del Reglamento (UE) n.º 833/2014 del Consejo",
//                 "id": 208910
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X834",
//                 "text": "Export authorization under article 3 duodecies, section 5, of Regulation (EU) No. 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3 duodecies, apartado 5, del Reglamento (UE) n.º 833/2014 del Consejo",
//                 "id": 208911
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X836",
//                 "text": "Export authorization under articles 2.4, letter b), or article 2 bis, section 4, letter b), of Regulation (EU) No. 2014/833 of the Council",
//                 "text_es": "Autorización de exportación en virtud de los artículos 2.4, letra b), o del artículo 2 bis, apartado 4, letra b), del Reglamento (UE) n.º 2014/833 del Consejo",
//                 "id": 208912
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X985",
//                 "text": "Export authorization under article 7 of Regulation (EU) 2022/263 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 7 del Reglamento (UE) 2022/263 del Consejo",
//                 "id": 208913
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X990",
//                 "text": "Export authorization under articles 2.4, 2 bis.4 and 2 ter, section 1, of Regulation (EU) No. 2014/833 of the Council",
//                 "text_es": "Autorización de exportación en virtud de los artículos 2.4, 2 bis.4 y 2 ter, apartado 1, del Reglamento (UE) n.º 2014/833 del Consejo",
//                 "id": 208914
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X991",
//                 "text": "The prohibitions defined in articles 2.1 and 2 bis.1 of Regulation (EU) No. 2014/833 of the Council are not applied (see contractual exemptions in the",
//                 "text_es": "No se aplican las prohibiciones definidas en los artículos 2.1 y 2 bis.1 del Reglamento (UE) n.º 2014/833 del Consejo (véanse las exenciones contractuales en el",
//                 "id": 208915
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X992",
//                 "text": "Export authorization, or emergency case, under article 3 ter, section 4, of Regulation (EU) No. 2014/833 of the Council",
//                 "text_es": "Autorización de exportación, o caso de emergencia, en virtud del artículo 3 ter, apartado 4, del Reglamento (UE) n.º 2014/833 del Consejo",
//                 "id": 208916
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "X002",
//                 "text": "Export authorization of double -use products (Regulation (CE) No. 428/2009 and modifications of the same).",
//                 "text_es": "Autorización de exportación de productos de doble uso (Reglamento (CE) nº 428/2009 y modificaciones del mismo).",
//                 "id": 208917
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "N270",
//                 "text": "Delivery note",
//                 "text_es": "Nota de entrega",
//                 "id": 208918
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NCLE",
//                 "text": "Reference/date of entry in the declarant's records",
//                 "text_es": "Referencia/fecha de entrada en los registros del declarante",
//                 "id": 208919
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NMNS",
//                 "text": "Cargo manifest simplified procedure",
//                 "text_es": "Manifiesto de carga Procedimiento simplificado",
//                 "id": 208920
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NMRN",
//                 "text": "Declaration / notification MRN",
//                 "text_es": "Declaración / notificación MRN",
//                 "id": 208921
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y039",
//                 "text": "Goods exempted from prohibition by virtue of Article 11 (a) or (b) of Reg. 2017/1509",
//                 "text_es": "Mercancías exentas de prohibición en virtud del artículo 11, letras a) o b), del Reglamento 2017/1509",
//                 "id": 209012
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y064",
//                 "text": "Wood and derived products originating or dispatched from a partner country of a voluntary association agreement (AAV) exported prior to the entrance",
//                 "text_es": "Madera y productos derivados originarios o despachados desde un país socio de un Acuerdo de Asociación Voluntaria (AAV) exportada con anterioridad a la entrada",
//                 "id": 209013
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y065",
//                 "text": "Products that do not come from India",
//                 "text_es": "Productos que no procedan de India",
//                 "id": 209014
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y067",
//                 "text": "GOODS PLACED UNDO A Special procedure referred to in art.5 (16) b) or in temporary storage referred to in art.5 (17) of regulation no 952/2013 at the end of the t",
//                 "text_es": "Goods placed under a special procedure referred to in Art.5(16)b) or in temporary storage referred to in Art.5(17) of Regulation No 952/2013 at the end of the t",
//                 "id": 209015
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y068",
//                 "text": "Products that do not come from North Korea",
//                 "text_es": "Productos que no procedan de Corea del Norte",
//                 "id": 209016
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y119",
//                 "text": "Dispensa of the preferential origin test within the framework of the EU preferential trade agreements",
//                 "text_es": "Dispensa de la prueba de origen preferencial en el marco de los acuerdos comerciales preferenciales de la UE",
//                 "id": 209017
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y127",
//                 "text": "Non -native or issued goods from Turkey",
//                 "text_es": "Mercancías no originarias ni expedidas desde Turquía",
//                 "id": 209018
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y222",
//                 "text": "United Kingdom - Continental Platform or Exclusive Economic Zone (Regulation (EU) 2019/1131 by which a customs instrument is established - DO L 179 of 3.7.201",
//                 "text_es": "Reino Unido - Plataforma continental o zona económica exclusiva (Reglamento (UE) 2019/1131 por el que se establece un instrumento aduanero - DO L 179 de 3.7.201",
//                 "id": 209019
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y818",
//                 "text": "The prohibitions defined in article 3, sections 1 and 2, of Regulation (EU) No. 833/2014 of the Council (see exemptions in the article do not apply",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3, apartados 1 y 2, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones en el artículo",
//                 "id": 209020
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y819",
//                 "text": "Export authorization under article 3c.6 of Regulation (EU) 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3c.6 del Reglamento (UE) 833/2014 del Consejo",
//                 "id": 209021
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y820",
//                 "text": "The prohibitions defined in article 3 sections 1 and 2 of Regulation (EU) No. 833/2014 of the Council are not applied (see contractual exemptions in",
//                 "text_es": "No se aplican las prohibiciones definidas en los artículo 3 apartados 1 y 2 del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractuales en",
//                 "id": 209022
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y821",
//                 "text": "Merchandise other than those affected by the prohibitions defined in article 3 Nonies, section 1, of Regulation (EU) No. 833/2014",
//                 "text_es": "Mercancías distintas de las afectadas por las prohibiciones definidas en el artículo 3 nonies, apartado 1, del Reglamento (UE) n.º 833/2014",
//                 "id": 209023
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y822",
//                 "text": "The prohibitions defined in article 3 nonies, section 1, of Regulation (EU) No. 833/2014 of the Council (see exemptions in articles do not apply",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 nonies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones en los artícu",
//                 "id": 209024
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y823",
//                 "text": "Export authorization under article 3 nonies, section 4, of Regulation (EU) No. 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3 nonies, apartado 4, del Reglamento (UE) n.º 833/2014 del Consejo",
//                 "id": 209025
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y824",
//                 "text": "Merchandise other than those affected by the prohibitions defined in article 3 Octies, section 1, of Regulation (EU) No. 833/2014",
//                 "text_es": "Mercancías distintas de las afectadas por las prohibiciones definidas en el artículo 3 octies, apartado 1, del Reglamento (UE) n.º 833/2014",
//                 "id": 209026
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y825",
//                 "text": "The prohibitions defined in article 3 octies quat.1, of Regulation (EU) No. 2014/833 of the Council are not applied (see contractual exemptions in",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 octies quater.1, del Reglamento (UE) n.º 2014/833 del Consejo (véanse las exenciones contractuales en",
//                 "id": 209027
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y830",
//                 "text": "Export authorization under article 3 quater, section 6, of Regulation (EU) No. 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3 quater, apartado 6, del Reglamento (UE) n.º 833/2014 del Consejo",
//                 "id": 209028
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y831",
//                 "text": "The prohibitions defined in article 3 decides are not applied, section 1, of Regulation (EU) No. 833/2014 of the Council (see the contractual exemptions",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 decies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractuales",
//                 "id": 209029
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y832",
//                 "text": "The prohibitions defined in article 3 duodecies are not applied, section 1, of Regulation (EU) No. 833/2014 of the Council (see the Contracting Exemptions",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 duodecies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractua",
//                 "id": 209030
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y833",
//                 "text": "The prohibitions defined in article 3 duodecies are not applied, section 1, of Regulation (EU) No. 833/2014 of the Council (see the exemptions in the Artí",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 duodecies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones en el artí",
//                 "id": 209031
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y834",
//                 "text": "Export authorization under article 3 duodecies, section 5, of Regulation (EU) No. 833/2014 of the Council",
//                 "text_es": "Autorización de exportación en virtud del artículo 3 duodecies, apartado 5, del Reglamento (UE) n.º 833/2014 del Consejo",
//                 "id": 209032
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y835",
//                 "text": "Merchandise other than those affected by the prohibitions defined in article 3 Decies section 1, of Regulation (EU) No. 833/2014",
//                 "text_es": "Mercancías distintas de las afectadas por las prohibiciones definidas en el artículo 3 decies apartado 1, del Reglamento (UE) n.º 833/2014",
//                 "id": 209033
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y836",
//                 "text": "Export authorization under articles 2.4, letter b), or article 2 bis, section 4, letter b), of Regulation (EU) No. 2014/833 of the Council",
//                 "text_es": "Autorización de exportación en virtud de los artículos 2.4, letra b), o del artículo 2 bis, apartado 4, letra b), del Reglamento (UE) n.º 2014/833 del Consejo",
//                 "id": 209034
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y838",
//                 "text": "The prohibitions defined in article 3 undecies are not applied, section.1, of Regulation (EU) No. 833/2014 of the Council (see the Contractual Exemptions",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 undecies, apartado.1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractual",
//                 "id": 209035
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y839",
//                 "text": "With a nominal diameter equal to or less than 350 mm.",
//                 "text_es": "Con un diámetro nominal igual o inferior a 350 mm.",
//                 "id": 209036
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y840",
//                 "text": "The prohibitions defined in article 3 undecies are not applied, section.1, of Regulation (EU) No. 833/2014 of the Council (see the Contractual Exemptions",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 undecies, apartado.1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractual",
//                 "id": 209037
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y841",
//                 "text": "The prohibitions defined in article 3 quatdecies are not applied, section 1, of Regulation (EU) No. 833/2014 of the Council [see exemptions in the",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 quaterdecies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo [véanse las exenciones en los",
//                 "id": 209038
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y842",
//                 "text": "The prohibitions defined in articles 3m.1 of Council Regulation (EU) No 833/2014 do not apply (see exemptions in articles 3m.9)",
//                 "text_es": "The prohibitions defined in article 3m.1 of Council Regulation (EU) No 833/2014 do not apply (see exemptions in article 3m.9)",
//                 "id": 209039
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y843",
//                 "text": "The prohibitions defined in article 3 sexDecies are not applied, paragraph 1, of Regulation (EU) No. 833/2014 of the Council [see exemptions in the Artí",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 sexdecies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo [véanse las exenciones en el artí",
//                 "id": 209040
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y845",
//                 "text": "Merchandise other than those affected by the prohibitions defined in article 3 sexDecies of Regulation (EU) No. 833/2014",
//                 "text_es": "Mercancías distintas de las afectadas por las prohibiciones definidas en el artículo 3 sexdecies del Reglamento (UE) n.º 833/2014",
//                 "id": 209041
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y846",
//                 "text": "Merchandise other than those affected by the prohibitions defined in article 2Aa of Regulation (EU) No. 833/2014",
//                 "text_es": "Mercancías distintas de las afectadas por las prohibiciones definidas en el artículo 2aa del Reglamento (UE) n.º 833/2014",
//                 "id": 209042
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y847",
//                 "text": "Merchandise other than those affected by the prohibitions defined in article 3c (5a) of Regulation (EU) No. 833/2014",
//                 "text_es": "Mercancías distintas de las afectadas por las prohibiciones definidas en el artículo 3c (5a) del Reglamento (UE) n.º 833/2014",
//                 "id": 209043
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y848",
//                 "text": "The prohibitions defined in article 3 quater.1, of Regulation (EU) No. 833/2014 of the Council are not applied (see the contractual exemptions in the art",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 quater.1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractuales en el art",
//                 "id": 209044
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y849",
//                 "text": "The prohibitions defined in article 3 octies quater.1, of Regulation (EU) No. 833/2014 of the Council are not applied (see contractual exemptions in",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 octies quater.1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractuales en",
//                 "id": 209045
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y850",
//                 "text": "The prohibitions defined in article 3 decides are not applied, section 1, of Regulation (EU) No. 833/2014 of the Council (see the contractual exemptions",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 decies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractuales",
//                 "id": 209046
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y851",
//                 "text": "The prohibitions defined in article 3 decides are not applied, section 1, of Regulation (EU) No. 833/2014 of the Council (see exemptions in the article",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 decies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones en el artícul",
//                 "id": 209047
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y852",
//                 "text": "The prohibitions defined in article 3 duodecies are not applied, section 1, of Regulation (EU) No. 833/2014 of the Council (see the Contracting Exemptions",
//                 "text_es": "No se aplican las prohibiciones definidas en el artículo 3 duodecies, apartado 1, del Reglamento (UE) n.º 833/2014 del Consejo (véanse las exenciones contractua",
//                 "id": 209048
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y853",
//                 "text": "Steel products transformed into a third country that do not incorporate steel products from Russia listed in Annex XVII of the Regulation",
//                 "text_es": "Productos siderúrgicos transformados en un tercer país que no incorporen productos siderúrgicos originarios de Rusia enumerados en el anexo XVII del Reglamento",
//                 "id": 209049
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y933",
//                 "text": "Goods not concerned by Article 4, paragraph 1 of Regulation (EU) No 208/2013.",
//                 "text_es": "Mercancías no afectadas por el artículo 4, apartado 1, del Reglamento (UE) no 208/2013.",
//                 "id": 209050
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y940",
//                 "text": "To the declared goods are not applied to the Execution Regulations (EU) No. 175/2015 of the Commission",
//                 "text_es": "A las mercancías declaradas no se les aplica el Reglamento de Ejecución (UE) No 175/2015 de la Comisión",
//                 "id": 209051
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y974",
//                 "text": "Customs regime other than export",
//                 "text_es": "Régimen aduanero distinto de la exportación",
//                 "id": 209052
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y997",
//                 "text": "Merchandise not originating from Crimea or Sebastopol or destined for them [Article 2, letter a), and article 2 ter, section 1, of Regulation (EU) No. 692/2014 of the",
//                 "text_es": "Mercancías no originarias de Crimea o Sebastopol ni destinadas a ellas [artículo 2, letra a), y artículo 2 ter, apartado 1, del Reglamento (UE) n.º 692/2014 del",
//                 "id": 209053
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y998",
//                 "text": "There are no reasonable reasons to determine that the goods are going to be used in Crimea or Sebastopol [Article 2 Ter, section 3, of Regulation (EU) No.",
//                 "text_es": "No existen motivos razonables para determinar que las mercancías vayan a utilizarse en Crimea o Sebastopol [artículo 2 ter, apartado 3, del Reglamento (UE) n.º",
//                 "id": 209054
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "I1032",
//                 "text": "Representation in ATC different from the state (values ​​4 or 5)",
//                 "text_es": "Representación en ATC diferente a la estatal.( valores 4 o 5 )",
//                 "id": 209157
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "I1033",
//                 "text": "It is an individual",
//                 "text_es": "Es un particular",
//                 "id": 209158
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "I5007",
//                 "text": "VAT subject, when the exporter is the acquirer of delivery",
//                 "text_es": "Sujeto IVA, cuando el exportador sea el adquirente de la entrega",
//                 "id": 209159
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "I5019",
//                 "text": "VAT subject, when the exporter is a third hired",
//                 "text_es": "Sujeto IVA, cuando el exportador sea un tercero contratado",
//                 "id": 209160
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NCLE",
//                 "text": "Domiciliation: Registration in stock accounting,",
//                 "text_es": "Domiciliación: inscripción en la contabilidad de existencias,",
//                 "id": 209161
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "NMRN",
//                 "text": "MRN number",
//                 "text_es": "Número de MRN",
//                 "id": 209162
//             }
//         ],
//         "additionalInfoCodes2": [
//             {
//                 "additionalInfo": "",
//                 "value": "100",
//                 "text": "Simplified authorisation",
//                 "text_es": "Autorización simplificada",
//                 "id": 208932
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "700",
//                 "text": "Discharge of inward processing. IP? and the relevant authorisation number or INF number",
//                 "text_es": "Descarga de procesamiento interno. IP? y el número de autorización o el número INF relevante",
//                 "id": 208933
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "800",
//                 "text": "Discharge of inward processing (specific commercial policy measures)",
//                 "text_es": "Descarga de procesamiento interno (medidas de política comercial específicas)",
//                 "id": 208934
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "900",
//                 "text": "Discharge of temporary admission. ?TA? and the relevant authorisation number",
//                 "text_es": "Descarga de admisión temporal. ?¿EJÉRCITO DE RESERVA? y el número de autorización relevante",
//                 "id": 208935
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "1000",
//                 "text": "Diplomatic Goods - Exempt from inspection",
//                 "text_es": "Bienes diplomáticos: exento de inspección",
//                 "id": 208936
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "30300",
//                 "text": "Export Id",
//                 "text_es": "ID de exportación",
//                 "id": 208937
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "30500",
//                 "text": "Where goods taken over under STC for transport out of customs territory of the Union to be the CoEXT",
//                 "text_es": "Donde los bienes tomados bajo STC para el transporte del territorio aduanero de la Unión para ser el coext",
//                 "id": 208938
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "30600",
//                 "text": "In EXS, where negotiable bills of lading 'to order blank endorsed' are concerned and the consignee particulars are unknown.",
//                 "text_es": "En exs, en lo que respecta a los proyectos de embarque negociables \"para ordenar en blanco\" y se desconocen los detalles del consignatario.",
//                 "id": 208939
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "30700",
//                 "text": "INF3",
//                 "text_es": "Inf3",
//                 "id": 208940
//             }
//         ],
//         "declaration": [
//             {
//                 "additionalInfo": "",
//                 "value": "CO",
//                 "text": "Trade of Union goods between EU customs territory not covered by the Council Directives 2006/112/EC or 2008/118/EC",
//                 "text_es": "Comercio de bienes sindicales entre el territorio de aduanas de la UE no cubierto por las Directivas del Consejo 2006/112/CE o 2008/118/CE",
//                 "id": 208930
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "EX",
//                 "text": "Export or re-export of goods outside of the customs territory of the Union",
//                 "text_es": "Exportación o reexportación de bienes fuera del territorio aduanero de la Unión",
//                 "id": 208931
//             }
//         ],
//         "goodsLocationType": [
//             {
//                 "additionalInfo": "",
//                 "value": "A",
//                 "text": "Designated place.",
//                 "text_es": "Lugar designado.",
//                 "id": 208941
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "B",
//                 "text": "Authorized place.",
//                 "text_es": "Lugar autorizado.",
//                 "id": 208942
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "C",
//                 "text": "Approved place.",
//                 "text_es": "Lugar aprobado.",
//                 "id": 208943
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "D",
//                 "text": "Others.",
//                 "text_es": "Otros.",
//                 "id": 208944
//             }
//         ],
//         "transactionNature": [
//             {
//                 "additionalInfo": "",
//                 "value": "13",
//                 "text": "Barter",
//                 "text_es": "Trueque",
//                 "id": 209242
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "14",
//                 "text": "Financial leasing",
//                 "text_es": "Arrendamiento Financiero",
//                 "id": 209243
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "15",
//                 "text": "Personal Purchases of Travelers",
//                 "text_es": "Compras personales de Viajeros",
//                 "id": 209244
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "19",
//                 "text": "Other transactions",
//                 "text_es": "Otras Transacciones",
//                 "id": 209245
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "29",
//                 "text": "Other transactions",
//                 "text_es": "Otras Transacciones",
//                 "id": 209246
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "4",
//                 "text": "Operations with a view to work on request",
//                 "text_es": "Operaciones con miras al Trabajo por Encargo",
//                 "id": 209247
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "40",
//                 "text": "Operations with a view to work on request",
//                 "text_es": "Operaciones con miras al Trabajo por Encargo",
//                 "id": 209248
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "43",
//                 "text": "Free repair/maintenance",
//                 "text_es": "Reparación/Mantenimiento Gratuito",
//                 "id": 209249
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "5",
//                 "text": "Operations after commission",
//                 "text_es": "Operaciones tras el Trabajo por Encargo",
//                 "id": 209250
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "50",
//                 "text": "Operations after commission",
//                 "text_es": "Operaciones tras el Trabajo por Encargo",
//                 "id": 209251
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "53",
//                 "text": "Free repair/maintenance",
//                 "text_es": "Reparación/Mantenimiento Gratuito",
//                 "id": 209252
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "6",
//                 "text": "Specific transactions registered for national purposes",
//                 "text_es": "Transacciones específicas registradas con fines nacionales",
//                 "id": 209253
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "60",
//                 "text": "Specific transactions registered for national purposes",
//                 "text_es": "Transacciones específicas registradas con fines nacionales",
//                 "id": 209254
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "7",
//                 "text": "Defense programs operations",
//                 "text_es": "Operaciones de Programas de Defensa",
//                 "id": 209255
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "80",
//                 "text": "Transactions that involve the supply of construction materials and technical team in the framework of a General Construction or Civil Engineering contract",
//                 "text_es": "Transacciones que implican el suministro de materiales de construcción y de equipo técnico en el marco de un contrato general de construcción o ingeniería civil",
//                 "id": 209256
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "9",
//                 "text": "Other transactions",
//                 "text_es": "Otras Transacciones",
//                 "id": 209257
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "90",
//                 "text": "Other transactions",
//                 "text_es": "Otras Transacciones",
//                 "id": 209258
//             }
//         ],
//         "packageCodes": [
//             {
//                 "additionalInfo": "",
//                 "value": "O1",
//                 "text": "Two sided cage on wheels with fixing strap",
//                 "text_es": "Caza de dos lados sobre ruedas con correa de fijación",
//                 "id": 208852
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O2",
//                 "text": "Trolley",
//                 "text_es": "Carretilla",
//                 "id": 208853
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O3",
//                 "text": "Oneway pallet ISO 0 - 1/2 EURO Pallet",
//                 "text_es": "Oneway Pallet ISO 0 - 1/2 Pallet euro",
//                 "id": 208854
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O4",
//                 "text": "Oneway pallet ISO 1 - 1/1 EURO Pallet",
//                 "text_es": "Oneway Pallet ISO 1 - 1/1 Pallet de euro",
//                 "id": 208855
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O5",
//                 "text": "Oneway pallet ISO 2 - 2/1 EURO Pallet",
//                 "text_es": "Oneway Pallet ISO 2 - 2/1 Pallet de euros",
//                 "id": 208856
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O6",
//                 "text": "Pallet with exceptional dimensions",
//                 "text_es": "Paleta con dimensiones excepcionales",
//                 "id": 208857
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O7",
//                 "text": "Wooden pallet 40 cm x 80 cm",
//                 "text_es": "Pallet de madera 40 cm x 80 cm",
//                 "id": 208858
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O8",
//                 "text": "Plastic pallet SRS 60 cm x 80 cm",
//                 "text_es": "Pallet de plástico SRS 60 cm x 80 cm",
//                 "id": 208859
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "O9",
//                 "text": "Plastic pallet SRS 80 cm x 120 cm",
//                 "text_es": "Pallet de plástico SRS 80 cm x 120 cm",
//                 "id": 208860
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OG",
//                 "text": "Pallet ISO 0 - 1/2 EURO Pallet",
//                 "text_es": "Pallet ISO 0 - 1/2 Palet de euros",
//                 "id": 208861
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OH",
//                 "text": "Pallet ISO 1 - 1/1 EURO Pallet",
//                 "text_es": "Pallet ISO 1 - 1/1 Palet de euros",
//                 "id": 208862
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OI",
//                 "text": "Pallet ISO 2 ? 2/1 EURO Pallet",
//                 "text_es": "Pallet ISO 2? 2/1 paleta euro",
//                 "id": 208863
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OJ",
//                 "text": "1/4 EURO Pallet",
//                 "text_es": "1/4 paleta euro",
//                 "id": 208864
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OL",
//                 "text": "1/8 EURO Pallet",
//                 "text_es": "1/8 de paleta euro",
//                 "id": 208865
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OM",
//                 "text": "Synthetic pallet ISO 1",
//                 "text_es": "Paleta sintética ISO 1",
//                 "id": 208866
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ON",
//                 "text": "Synthetic pallet ISO 2",
//                 "text_es": "Paleta sintética ISO 2",
//                 "id": 208867
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OP",
//                 "text": "Wholesaler pallet",
//                 "text_es": "Paleta mayorista",
//                 "id": 208868
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OQ",
//                 "text": "Pallet 80 X 100 cm",
//                 "text_es": "Pallet 80 x 100 cm",
//                 "id": 208869
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OR",
//                 "text": "Pallet 60 X 100 cm",
//                 "text_es": "Pallet 60 x 100 cm",
//                 "id": 208870
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OS",
//                 "text": "Oneway pallet",
//                 "text_es": "Paleta",
//                 "id": 208871
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OV",
//                 "text": "Returnable pallet",
//                 "text_es": "Paleta retornable",
//                 "id": 208872
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OW",
//                 "text": "Large bag, pallet sized",
//                 "text_es": "Bolsa grande, tamaño de paleta",
//                 "id": 208873
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OX",
//                 "text": "A wheeled pallet with raised rim (81 x 67 x 135)",
//                 "text_es": "Una paleta con llanta elevada (81 x 67 x 135)",
//                 "id": 208874
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OY",
//                 "text": "A Wheeled pallet with raised rim (81 x 72 x 135)",
//                 "text_es": "Una paleta con llanta elevada (81 x 72 x 135)",
//                 "id": 208875
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "OZ",
//                 "text": "Wheeled pallet with raised rim ( 81 x 60 x 16)",
//                 "text_es": "Palet de ruedas con borde elevado (81 x 60 x 16)",
//                 "id": 208876
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "P1",
//                 "text": "CHEP pallet 60 cm x 80 cm",
//                 "text_es": "Pallet Chep 60 cm x 80 cm",
//                 "id": 208877
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "P3",
//                 "text": "LPR pallet 60 cm x 80 cm",
//                 "text_es": "LPR Pallet 60 cm x 80 cm",
//                 "id": 208878
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "P4",
//                 "text": "LPR pallet 80 cm x 120 cm",
//                 "text_es": "LPR Pallet 80 cm x 120 cm",
//                 "id": 208879
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ZL",
//                 "text": "R in grn solid mat com re in plr",
//                 "text_es": "R in grn sólid mat com re in pl rí",
//                 "id": 208880
//             }
//         ],
//         "authorisationType": [
//             {
//                 "additionalInfo": "",
//                 "value": "C626",
//                 "text": "BTI - Decision relating to Binding Tariff Information (Column 1a, Annex A of Delegated Regulation (EU) 2015/2446)",
//                 "text_es": "BTI - Decisión relacionada con la información de tarifa vinculante (columna 1A, Anexo A de regulación delegada (UE) 2015/2446)",
//                 "id": 209124
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "C627",
//                 "text": "BOI - Decision relating to Binding Origin Information (Column 1b, Annex A of Delegated Regulation (EU) 2015/2446)",
//                 "text_es": "BOI - Decisión relacionada con la información de origen vinculante (columna 1b, Anexo A de regulación delegada (UE) 2015/2446)",
//                 "id": 209125
//             }
//         ],
//         "customOffice": [
//             {
//                 "additionalInfo": "",
//                 "value": "ES005503",
//                 "text": "Ceuta heliport",
//                 "text_es": "CEUTA HELIPUERTO",
//                 "id": 206839
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ES005511",
//                 "text": "Ceuta Maritima",
//                 "text_es": "CEUTA MARITIMA",
//                 "id": 206840
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ES005513",
//                 "text": "Ceuta postcards",
//                 "text_es": "CEUTA POSTALES",
//                 "id": 206841
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ES005541",
//                 "text": "Ceuta Road",
//                 "text_es": "CEUTA CARRETERA",
//                 "id": 206842
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ES005601",
//                 "text": "Melilla Airport",
//                 "text_es": "MELILLA AEROPUERTO",
//                 "id": 206843
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ES005611",
//                 "text": "Melilla Maritima",
//                 "text_es": "MELILLA MARITIMA",
//                 "id": 206844
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ES005613",
//                 "text": "Melilla postcards",
//                 "text_es": "MELILLA POSTALES",
//                 "id": 206845
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "ES005641",
//                 "text": "Melilla Road",
//                 "text_es": "MELILLA CARRETERA",
//                 "id": 206846
//             }
//         ],
//         "methodOfPayment": [
//             {
//                 "additionalInfo": "",
//                 "value": "A",
//                 "text": "Payment in cash",
//                 "text_es": "Pago en efectivo",
//                 "id": 208897
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "B",
//                 "text": "Payment by credit card",
//                 "text_es": "Pago con tarjeta de crédito",
//                 "id": 208898
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "C",
//                 "text": "Payment by cheque",
//                 "text_es": "Pago por cheque",
//                 "id": 208899
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "D",
//                 "text": "Other",
//                 "text_es": "Otro",
//                 "id": 208900
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "H",
//                 "text": "Electronic credit transfer",
//                 "text_es": "Transferencia electrónica de crédito",
//                 "id": 208901
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y",
//                 "text": "Account holder with carrier",
//                 "text_es": "Titular de cuentas con operador",
//                 "id": 208902
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Z",
//                 "text": "Not pre-paid",
//                 "text_es": "No prepagado",
//                 "id": 208903
//             }
//         ],
//         "dispatchRegion": [
//             {
//                 "additionalInfo": "",
//                 "value": "61",
//                 "text": "Fuerteventura",
//                 "text_es": "FUERTEVENTURA",
//                 "id": 209150
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "62",
//                 "text": "Lanzarote",
//                 "text_es": "LANZAROTE",
//                 "id": 209151
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "63",
//                 "text": "Gran Canaria",
//                 "text_es": "GRAN CANARIA",
//                 "id": 209152
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "64",
//                 "text": "The gomera",
//                 "text_es": "LA GOMERA",
//                 "id": 209153
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "65",
//                 "text": "THE IRON",
//                 "text_es": "EL HIERRO",
//                 "id": 209154
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "66",
//                 "text": "THE PALM",
//                 "text_es": "LA PALMA",
//                 "id": 209155
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "67",
//                 "text": "Tenerife",
//                 "text_es": "TENERIFE",
//                 "id": 209156
//             }
//         ],
//         "previousProcedure": [
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1000",
//                 "text": "Export/final expedition",
//                 "text_es": "Exportación/Expedición definitiva",
//                 "id": 209173
//             },
//             {
//                 "additionalInfo": "CO",
//                 "value": "1001",
//                 "text": "Practical Merc.Ibre",
//                 "text_es": "expedición merc.libre práctica",
//                 "id": 209174
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1007",
//                 "text": "Export/Expedition from DDA or Ref",
//                 "text_es": "Export/Expedición desde DDA o REF",
//                 "id": 209175
//             },
//             {
//                 "additionalInfo": "EX,EU",
//                 "value": "1021",
//                 "text": "Export.Definitive merchandise in RPP",
//                 "text_es": "export.definitiva mercancia en RPP",
//                 "id": 209176
//             },
//             {
//                 "additionalInfo": "EX,EU,CO",
//                 "value": "1022",
//                 "text": "Exp.Definitive merchandise in RPP Econom.",
//                 "text_es": "exp.definitiva mercancia en RPP econom.",
//                 "id": 209177
//             },
//             {
//                 "additionalInfo": "EX,EU,CO",
//                 "value": "1023",
//                 "text": "EXPT.TEAMPORA EXPT",
//                 "text_es": "Exportación definitiva de expt.tempora",
//                 "id": 209178
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1040",
//                 "text": "Export/expedition. Return",
//                 "text_es": "Exportación/Expedición. Devolución",
//                 "id": 209179
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1043",
//                 "text": "Export/Expedition from DDA or Ref",
//                 "text_es": "Export/Expedición desde DDA o REF",
//                 "id": 209180
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1049",
//                 "text": "Export/Expedition from DDA or Ref",
//                 "text_es": "Export/Expedición desde DDA o REF",
//                 "id": 209181
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1073",
//                 "text": "Export/Expedition MER DDA O REF",
//                 "text_es": "Export/Expedición merc DDA o REF",
//                 "id": 209182
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1078",
//                 "text": "Export/Expedition ZF/DF",
//                 "text_es": "Exportación/Expedición ZF/DF",
//                 "id": 209183
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1095",
//                 "text": "Export/Expedition MER DDA O REF",
//                 "text_es": "Export/Expedición merc DDA o REF",
//                 "id": 209184
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "1100",
//                 "text": "EXPORT/EXPRESS. Export rpa",
//                 "text_es": "Export/Exped. RPA export.anticipada",
//                 "id": 209185
//             },
//             {
//                 "additionalInfo": "EU,EX,CO",
//                 "value": "2100",
//                 "text": "Linking to RPP",
//                 "text_es": "Vinculación a RPP",
//                 "id": 209186
//             },
//             {
//                 "additionalInfo": "EU,EX,CO",
//                 "value": "2107",
//                 "text": "Linking to RPP merchandise in DDA",
//                 "text_es": "Vinculación a RPP mercancía en DDA",
//                 "id": 209187
//             },
//             {
//                 "additionalInfo": "EU,EX",
//                 "value": "2148",
//                 "text": "Standard exchange export",
//                 "text_es": "Exportación intercambio estandar",
//                 "id": 209188
//             },
//             {
//                 "additionalInfo": "EU,EX",
//                 "value": "2151",
//                 "text": "RPP Linking after RPA",
//                 "text_es": "Vinculación RPP tras RPA",
//                 "id": 209189
//             },
//             {
//                 "additionalInfo": "EU,EX",
//                 "value": "2200",
//                 "text": "Linking to RPP different from 21",
//                 "text_es": "Vinculación a RPP distinto del 21",
//                 "id": 209190
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "2300",
//                 "text": "Temporary export",
//                 "text_es": "Exportación temporal",
//                 "id": 209191
//             },
//             {
//                 "additionalInfo": "EU,EX",
//                 "value": "3121",
//                 "text": "Merca re -export. RPP after Vinc.Da",
//                 "text_es": "Reexportación merca. RPP tras vinc.DA",
//                 "id": 209192
//             },
//             {
//                 "additionalInfo": "EU,EX,CO",
//                 "value": "3151",
//                 "text": "Reexportation after RPA",
//                 "text_es": "Reexportación tras RPA",
//                 "id": 209193
//             },
//             {
//                 "additionalInfo": "CO,EU,EX",
//                 "value": "3153",
//                 "text": "Reexportation after import. temporary",
//                 "text_es": "Reexportación tras import. temporal",
//                 "id": 209194
//             },
//             {
//                 "additionalInfo": "EU,EX,CO",
//                 "value": "3154",
//                 "text": "Reexportation after RPA in another EM",
//                 "text_es": "Reexportación tras RPA en otro EM",
//                 "id": 209195
//             },
//             {
//                 "additionalInfo": "EU,EX",
//                 "value": "3171",
//                 "text": "Reexportation after Vinc.Da",
//                 "text_es": "Reexportación tras vinc.DA",
//                 "id": 209196
//             },
//             {
//                 "additionalInfo": "EU,EX",
//                 "value": "3178",
//                 "text": "Reexportation after Vinc.Da",
//                 "text_es": "Reexportación tras vinc.DA",
//                 "id": 209197
//             }
//         ],
//         "warehouseType": [
//             {
//                 "additionalInfo": "",
//                 "value": "R",
//                 "text": "Public customs warehouse type I",
//                 "text_es": "Almacén de Aduanas Públicas Tipo I",
//                 "id": 208890
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "S",
//                 "text": "Public customs warehouse type II",
//                 "text_es": "Almacén de Aduanas Públicas Tipo II",
//                 "id": 208891
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "T",
//                 "text": "Public customs warehouse type III",
//                 "text_es": "Almacén de Aduanas Públicas Tipo III",
//                 "id": 208892
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "U",
//                 "text": "Private customs warehouse",
//                 "text_es": "Almacén de aduanas privadas",
//                 "id": 208893
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "V",
//                 "text": "Storage facilities for the temporary storage of goods",
//                 "text_es": "Instalaciones de almacenamiento para el almacenamiento temporal de productos",
//                 "id": 208894
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Y",
//                 "text": "Non-customs warehouse",
//                 "text_es": "Almacén de no sustitutos",
//                 "id": 208895
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "Z",
//                 "text": "Free zone or free warehouse",
//                 "text_es": "Zona libre o almacén gratuito",
//                 "id": 208896
//             }
//         ],
//         "transportMean": [
//             {
//                 "additionalInfo": "",
//                 "value": "10",
//                 "text": "IMO Ship Identification Number",
//                 "text_es": "Número de identificación de la OMI de buques",
//                 "id": 208922
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "11",
//                 "text": "Name of the sea-going vessel",
//                 "text_es": "Nombre de la embarcación marina",
//                 "id": 208923
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "21",
//                 "text": "Train Number",
//                 "text_es": "Número de tren",
//                 "id": 208924
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "30",
//                 "text": "Registration Number of the Road Vehicle",
//                 "text_es": "Número de registro del vehículo de carretera",
//                 "id": 208925
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "40",
//                 "text": "IATA flight number",
//                 "text_es": "Número de vuelo de IATA",
//                 "id": 208926
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "41",
//                 "text": "Registration Number of the Aircraft",
//                 "text_es": "Número de registro de la aeronave",
//                 "id": 208927
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "80",
//                 "text": "European Vessel Identification Number (ENI Code)",
//                 "text_es": "Número de identificación de buques europeos (código ENI)",
//                 "id": 208928
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "81",
//                 "text": "Name of the inland waterways vessel",
//                 "text_es": "Nombre del barco de vías navegables interiores",
//                 "id": 208929
//             }
//         ],
//         "supplyChainActorRole": [
//             {
//                 "additionalInfo": "",
//                 "value": "CS",
//                 "text": "Consolidor",
//                 "text_es": "Consolidador",
//                 "id": 209126
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "FW",
//                 "text": "Transitary",
//                 "text_es": "Transitario",
//                 "id": 209127
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "MF",
//                 "text": "Maker",
//                 "text_es": "Fabricante",
//                 "id": 209128
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "WH",
//                 "text": "Depositary",
//                 "text_es": "Depositario",
//                 "id": 209129
//             }
//         ],
//         "additionalProcedure": [
//             {
//                 "additionalInfo": "",
//                 "value": "121",
//                 "text": "RETURN II.EE",
//                 "text_es": "devolución II.EE",
//                 "id": 209198
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "122",
//                 "text": "Merc.en reg. Speaker ad exp = ad. exit",
//                 "text_es": "Merc.en reg.suspensivo Ad exp=Ad. salida",
//                 "id": 209199
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "123",
//                 "text": "Exp reg.Susps. Ad expi no = ad salt salt",
//                 "text_es": "EXP reg.susps. Ad exp no=Ad sal nacional",
//                 "id": 209200
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "124",
//                 "text": "Shipping to Canary Islands P. Intermedios, alcohol.",
//                 "text_es": "Envios a Canarias p.intermedios,alcohol.",
//                 "id": 209201
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "125",
//                 "text": "Exp ie Type 0 or without return request",
//                 "text_es": "Exp IE tipo 0 o sin solicitud devoluci",
//                 "id": 209202
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "126",
//                 "text": "Exp reg regaging another em.",
//                 "text_es": "Exp reg suspensivo salida otro EM",
//                 "id": 209203
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "128",
//                 "text": "Shipping to Canary Islands P. Intermedios, alcohol.",
//                 "text_es": "Envios a Canarias p.intermedios,alcohol.",
//                 "id": 209204
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "129",
//                 "text": "SUSPENSIVE REPOSIVE ULIMATION IN TAX FREE",
//                 "text_es": "Ultimación reg suspensivo en tiendas libres de impuestos",
//                 "id": 209205
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "141",
//                 "text": "Tax free stores",
//                 "text_es": "Tiendas libres de impuestos",
//                 "id": 209206
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "142",
//                 "text": "e-commerce",
//                 "text_es": "e-commerce",
//                 "id": 209207
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "143",
//                 "text": "Ceuta or Melilla commercial document",
//                 "text_es": "Documento comercial Ceuta o Melilla",
//                 "id": 209208
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "144",
//                 "text": "Simplified Procedure with Andorra",
//                 "text_es": "Procedimiento simplificado con Andorra",
//                 "id": 209209
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "145",
//                 "text": "Export for alleged act, nor ga 35/20",
//                 "text_es": "Exportación por acto presunto, NI GA 35/20",
//                 "id": 209210
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "177",
//                 "text": "Authorization Grouping Parties",
//                 "text_es": "Autorización agrupación partidas",
//                 "id": 209211
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "421",
//                 "text": "Merchandise export with the Islt supported",
//                 "text_es": "Exportación mercancías con el ISLT soportado",
//                 "id": 209212
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "422",
//                 "text": "Export that finalizes the Islt suspensive regime",
//                 "text_es": "Exportación que ultima el régimen suspensivo ISLT",
//                 "id": 209213
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "801",
//                 "text": "Rea: Prod. Art. 13.6 RGTO 180/2014",
//                 "text_es": "REA: Prod. Art. 13.6 Rgto 180/2014",
//                 "id": 209214
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "802",
//                 "text": "Rea: Prod. Art. 13.3 RGTO 180/2014",
//                 "text_es": "REA: Prod. Art. 13.3 Rgto 180/2014",
//                 "id": 209215
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "803",
//                 "text": "Rea: Prod. Art. 13.4 RGTO 180/2014",
//                 "text_es": "REA: Prod. Art. 13.4 Rgto 180/2014",
//                 "id": 209216
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "804",
//                 "text": "Rea: Prod. Art. 13.5 RGTO 180/2014",
//                 "text_es": "REA: Prod. Art. 13.5 Rgto 180/2014",
//                 "id": 209217
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "805",
//                 "text": "REA: Prod. Transformed Traditional Current",
//                 "text_es": "REA: Prod. Transformado Corriente Tradicional",
//                 "id": 209218
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "806",
//                 "text": "REA: Prod. Transformed Regional Trade",
//                 "text_es": "REA: Prod. Transformado Comercio Regional",
//                 "id": 209219
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "c",
//                 "text": "Provisional weight and value",
//                 "text_es": "Peso y valor provisionales",
//                 "id": 209220
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "9VA",
//                 "text": "Provisional value",
//                 "text_es": "Valor provisional",
//                 "id": 209221
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "A51",
//                 "text": "Prod.compensadores from milk/ lacte",
//                 "text_es": "Prod.compensadores a partir leche/ lacte",
//                 "id": 209222
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "A52",
//                 "text": "Prod.compensadores Fiscal RPA",
//                 "text_es": "Prod.compensadores RPA fiscal",
//                 "id": 209223
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "A53",
//                 "text": "Prod.compensadores Military Use",
//                 "text_es": "Prod.compensadores RPA uso militar",
//                 "id": 209224
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "B51",
//                 "text": "Merc. In RPA exported at RPP Repair",
//                 "text_es": "Merc. en RPA exportada en RPP reparac",
//                 "id": 209225
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "B52",
//                 "text": "Merc. In exported RPA for substitution",
//                 "text_es": "Merc. en RPA exportada para sustitución",
//                 "id": 209226
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "B53",
//                 "text": "RPP Agreements 3 countries combined VAT",
//                 "text_es": "RPP acuerdos 3 paises combinado IVA",
//                 "id": 209227
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "B54",
//                 "text": "RPP VAT",
//                 "text_es": "RPP IVA",
//                 "id": 209228
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "C51",
//                 "text": "Animals dom. Explorat transfer. agricultural",
//                 "text_es": "Animales dom. traslado explot. agricola",
//                 "id": 209229
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "C52",
//                 "text": "Forages and food tralado animals",
//                 "text_es": "Forrajes y alimentos tralado animales",
//                 "id": 209230
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E51",
//                 "text": "Merc. ANNEX I.",
//                 "text_es": "Restitución merc. anexo I",
//                 "id": 209231
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E52",
//                 "text": "Merc. ANNEX I WITHOUT CERTIFICATED",
//                 "text_es": "Restitución merc. anexo I sin certificad",
//                 "id": 209232
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E53",
//                 "text": "Restituc. Merc. ANNEX I WITHOUT CERTIFY, PE",
//                 "text_es": "Restituc. merc. anexo I sin certific, pe",
//                 "id": 209233
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E61",
//                 "text": "Merc. Annex II",
//                 "text_es": "Restitución merc. anexo II",
//                 "id": 209234
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E62",
//                 "text": "Merc. NO ANNEX I WITHOUT CERTIF",
//                 "text_es": "Restitución merc. no anexo I sin certif",
//                 "id": 209235
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E63",
//                 "text": "Restituc. Merc. No annex and small ca,",
//                 "text_es": "Restituc. merc. no anexo I pequeñas ca,",
//                 "id": 209236
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "E71",
//                 "text": "Rest Prods Agricolas Small amounts",
//                 "text_es": "Rest prods agricolas pequeñas cantidades",
//                 "id": 209237
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "F51",
//                 "text": "Export for military use",
//                 "text_es": "Exportación para uso militar",
//                 "id": 209238
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "F61",
//                 "text": "AVITUALLATION",
//                 "text_es": "Avituallamiento",
//                 "id": 209239
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "F62",
//                 "text": "Restitution provision",
//                 "text_es": "Avituallamiento con restitución",
//                 "id": 209240
//             },
//             {
//                 "additionalInfo": "",
//                 "value": "F63",
//                 "text": "Entry in provisioning warehouse",
//                 "text_es": "Entrada en almacen de avituallamiento",
//                 "id": 209241
//             }
//         ]
//     }
export const useGetDropdownData = (payload) => {
  const dispatch = useDispatch();
  useEffect(() => {

    const intilizeDropDownCalls = async () => {
      try {
        const data = {
          eventMessage: payload,
          eventType: `GET_DROPDOWN_VALUES_${payload.countryCode.toUpperCase()}`,
          eventTime: Date.now(),
        }
        const response = await HttpClient.custom({ data })
        dispatch(initializeDropDownValues(response.data.eventMessage))
      } catch (err) { }
    }
    // dispatch(initializeDropDownValues(data))
    intilizeDropDownCalls()

  }, [JSON.stringify(payload)])
  return true;
}

